module.exports = __webpack_public_path__ + "img/jelly-logo.68d29b33.svg";